module.exports = __webpack_public_path__ + "static/media/examination-icon-6.2bd61618.png";